export const generateZoomBasedOnWidth = (fallback = null) => {
  if (typeof window === "undefined" || !window || !window.matchMedia) {
    return fallback;
  }

  return window.matchMedia("(max-width: 599px)").matches
    ? 5.6
    : window.matchMedia("(min-width: 600px) and (max-width: 899px)").matches
      ? 5.9
      : window.matchMedia("(min-width: 900px)").matches
        ? 6.3
        : fallback;
};

export const initialMapView = {
  longitude: 7.8112,
  latitude: 51.4332,
  zoom: generateZoomBasedOnWidth(),
};
